module.exports = __webpack_public_path__ + "assets/img/heat-diy.active.066ff44d.jpg";